import Container from './FolderList.container';
import Desktop from './FolderListDesktop';
import Mobile from './FolderListMobile';

export const FolderListDesktop = Container(Desktop);
export const FolderListMobile = Container(Mobile);
